export enum enumIsfSubStep {
  CONSIGNEE_DETAILS = 'CONSIGNEE_DETAILS',
  BUYER_DETAILS = 'BUYER_DETAILS',
  SHIP_TO_DETAILS = 'SHIP_TO_DETAILS',
  SUPPLIER_DETAILS = 'SUPPLIER_DETAILS',
  CONSOLIDATOR_DETAILS = 'CONSOLIDATOR_DETAILS',
  CONTAINER_STUFFING_LOCATION_DETAILS = 'CONTAINER_STUFFING_LOCATION_DETAILS',
  MANUFACTURER_DETAILS = 'MANUFACTURER_DETAILS',
  INTERNATIONAL_HTS_CODE_DETAILS = 'INTERNATIONAL_HTS_CODE_DETAILS',
  BILL_OF_LADING_DETAILS = 'BILL_OF_LADING_DETAILS',
}
